import React, { useEffect, useState } from 'react';
import './DataTable.css';
import API_BASE_URL from '../../config';
import Navbar from '../Navbar/Navbar';

function DataTable() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20);
  const [searchTerm, setSearchTerm] = useState('');

  // Mapeamento de status
  const statusMap = {
    1: 'Despacho Notificação',
    2: 'Relatório',
    3: 'Análise Técnica',
    4: 'Solicitado Documentação',
    5: 'Análise Documental',
    6: 'Análise Encerramento',
    7: 'Deferido',
    8: 'Indeferido',
    9: 'Arquivado',
    10: 'Recebimento do Pedido'
  };

  const statusTipo = {
    1: 'AC 1',
    2: 'AC 2',
  };

  // Função para extrair o ano e o número do processo corretamente
  const extractProcessDetails = (processo) => {
    const match = processo.match(/(\d{5})\.(\d{6})\/(\d{4})-(\d{2})$/); // Ajuste da regex para extrair todos os números
    const year = match ? parseInt(match[3], 10) : 0;
    const number = match ? parseInt(match[2], 10) : 0; // Extraindo o número do processo completo, ignorando os zeros à esquerda
    return { year, number };
  };

  // Ordenar os processos pelo ano e, em seguida, pelo número do processo
  const sortProcesses = (a, b) => {
    const processA = extractProcessDetails(a.processo);
    const processB = extractProcessDetails(b.processo);

    // Comparar pelo ano
    if (processA.year !== processB.year) {
      return processA.year - processB.year;
    }

    // Se o ano for o mesmo, comparar pelo número do processo numericamente
    return processA.number - processB.number;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/ac`);
        if (!response.ok) {
          throw new Error(`Erro na requisição: ${response.status} ${response.statusText}`);
        }
        const result = await response.json();

        // Ordenar os dados por processo (primeiro ano, depois número)
        result.sort(sortProcesses);
        setData(result);
      } catch (error) {
        console.error('Erro ao buscar dados:', error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const filteredData = data.filter(item =>
      item.processo.toString().includes(searchTerm)
  );

  const sortedData = [...filteredData].sort(sortProcesses);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(sortedData.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const getStatusBorderClass = (status) => {
    switch (statusMap[status]) {
      case 'Recebimento do Pedido':
        return 'borda-cinza';
      case 'Análise Técnica':
        return 'borda-azul-claro';
      case 'Análise Documental':
        return 'borda-azul-escuro';
      case 'Relatório':
        return 'borda-verde-claro';
      case 'Despacho Notificação':
        return 'borda-verde-escuro';
      case 'Análise Encerramento':
        return 'borda-roxo';
      case 'Solicitado Documentação':
        return 'borda-vermelho';
      default:
        return ''; // sem borda
    }
  };

  return (
      <div className="">
        <Navbar searchTerm={searchTerm} onSearchChange={setSearchTerm} />
        <div className="table-container">
          {loading ? (
              <p>Carregando...</p>
          ) : (
              <>
                <table className="data-table">
                  <thead>
                  <tr>
                    <th>Ordem</th>
                    <th>Tipo</th>
                    <th>Processo</th>
                    <th>Data da Movimentação</th>
                    <th>Status</th>
                    <th>Etapa</th>
                  </tr>
                  </thead>
                  <tbody>
                  {currentItems.length > 0 ? (
                      currentItems.map((item, index) => (
                          <tr key={item.id_ac_atendimento}>
                            <td data-label="Ordem">{indexOfFirstItem + index + 1}</td>
                            <td data-label="Tipo">{statusTipo[item.tipo]}</td>
                            <td data-label="Processo">{item.processo}</td>
                            <td data-label="Data da Movimentação">{item.dataMovimentacao}</td>
                            <td data-label="Status">
                              <div className={getStatusBorderClass(item.status)}>
                                {statusMap[item.status] || 'Status desconhecido'}
                              </div>
                            </td>
                            <td data-label="Etapa">{item.etapa}</td>
                          </tr>
                      ))
                  ) : (
                      <tr>
                        <td colSpan="7">Nenhum credenciamento encontrado!</td>
                      </tr>
                  )}
                  </tbody>
                </table>
                <div className="pagination">
                  <button
                      onClick={prevPage}
                      className="page-button"
                      disabled={currentPage === 1}
                  >
                    Anterior
                  </button>
                  {Array.from({ length: totalPages }, (_, i) => (
                      <button
                          key={i + 1}
                          onClick={() => paginate(i + 1)}
                          className={`page-button ${currentPage === i + 1 ? 'active' : ''}`}
                      >
                        {i + 1}
                      </button>
                  ))}
                  <button
                      onClick={nextPage}
                      className="page-button"
                      disabled={currentPage === totalPages}
                  >
                    Próxima
                  </button>
                </div>
              </>
          )}
        </div>
      </div>
  );
}

export default DataTable;
